import "./snow-report-page.scss"

export default async function init() {
  if (!document.querySelector(".resort-snow-report__map")) return

  const { default: SnowReportPage } = await import(
    /* webpackChunkName: 'snow-report-page' */ "./snow-report-page"
  )

  SnowReportPage()
}
